import React from "react";

import { Icon, Typography } from "components";

type ScenarioStatCardProps = {
  /** Legend dot colour matching the scenario's chart line. */
  dotColor: "green" | "blue";
  title: string;
  value: string;
  caption: string;
  /** Optional highlighted chip next to the title (e.g. the uplift figure). */
  chipText?: string;
  /** Chip flavour: "up" = yellow with trending-up icon, "down" = salmon with trending-down; omitted = no icon. */
  chipTrend?: "up" | "down";
  dataTestId?: string;
};

// Figma stat card used on steps 2 and 4: legend dot + scenario name (14/24 semibold),
// big value (26/34 medium), caption (12/16 regular).
export const ScenarioStatCard = ({ dotColor, title, value, caption, chipText, chipTrend, dataTestId }: ScenarioStatCardProps) => (
  <div className="onboarding-scenario-card" data-testid={dataTestId}>
    <div className="onboarding-scenario-card__header">
      <span className={`onboarding-scenario-card__dot onboarding-scenario-card__dot--${dotColor}`} />
      <Typography variant="h6">{title}</Typography>
      {chipText && (
        <span className={`onboarding-scenario-card__chip${chipTrend === "down" ? " onboarding-scenario-card__chip--negative" : ""}`}>
          {/* A scenario that lands on the baseline moves in no direction — the chip carries the number alone. */}
          {chipTrend && <Icon iconName={chipTrend === "down" ? "tabler/trending-down" : "tabler/trending-up"} size="xs" />}
          {chipText}
        </span>
      )}
    </div>
    <Typography variant="h2" className="onboarding-scenario-card__value">
      {value}
    </Typography>
    <Typography variant="paragraph-s" color="grey-600" className="onboarding-scenario-card__caption">
      {caption}
    </Typography>
  </div>
);
